const lookbooks_buttons = document.querySelectorAll(".js-lookbook");

if(lookbooks_buttons) [...lookbooks_buttons].forEach(button => {
  button.addEventListener("click", (e) => {
    const id = e.target.dataset.sectionId;

    if(!id) return;

    const lookbook = document.querySelector("#lookbook-" + id);

    if(!lookbook) return;

    if(lookbook.classList.contains("open")) lookbook.classList.remove("open");
    else lookbook.classList.add("open");

    lookbook.addEventListener("click", (e) => {
      console.log("test")
      if(lookbook.classList.contains("open")) lookbook.classList.remove("open");
    })

    const content = lookbook.querySelector(".lookbook-content");

    if(!content) return;

    content.addEventListener("click", (e) => {
      e.stopPropagation();
    })
  })
})